import { render } from "./MailingBlockText.vue?vue&type=template&id=a40e0650"
import script from "./MailingBlockText.vue?vue&type=script&lang=js"
export * from "./MailingBlockText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__